import React from 'react';
import {
  AdmissionTabButtonWrapper,
  RoundedButton,
  SectionContainerWrapper
} from '../styled';
import pallet from '../../../layouts/pallet';
import { admissionTypeTabs } from '../utils/constant';
import { AdmissionTypeTabProps } from '../types';

const getButtonColors = (isActive: boolean) => ({
  backgroundColor: isActive ? pallet.primary : pallet.white,
  boxShadow: isActive ? '0px 2px 4px 0px rgba(105, 108, 255, 0.4)' : 'none',
  textColor: isActive ? pallet.white : pallet.formLabelText
});

const AdmissionTypeTab: React.FC<AdmissionTypeTabProps> = ({
  admissionType,
  setAdmissionType
}) => {
  return (
    <SectionContainerWrapper>
      <AdmissionTabButtonWrapper>
        {admissionTypeTabs.map(({ key, label, IconActive, IconInactive }) => {
          const isActive = admissionType === key;
          const Icon = isActive ? IconActive : IconInactive;
          const { backgroundColor, textColor, boxShadow } =
            getButtonColors(isActive);

          return (
            <RoundedButton
              key={key}
              backgroundColor={backgroundColor}
              textColor={textColor}
              boxShadow={boxShadow}
              onClick={() => setAdmissionType(key)}
            >
              <Icon style={{ marginRight: '6px' }} />
              {label}
            </RoundedButton>
          );
        })}
      </AdmissionTabButtonWrapper>
    </SectionContainerWrapper>
  );
};

export default AdmissionTypeTab;
